import { __awaiter, __generator } from "tslib";
import { getHashOrNull } from '../../utils';
import { logger } from '../../../logger';
import { version } from '../../constants';
export default (function (analytics, options) {
    if (!window.MsCrmMkt) {
        logger.error('Dynamics365MarketingPlugin: window.MsCrmMkt is not defined');
        return;
    }
    var formIdToNameMappings = typeof options.dynamics365Marketing == 'object'
        ? options.dynamics365Marketing.formIdToNameMappings || {}
        : {};
    window.MsCrmMkt.MsCrmFormLoader.on('afterFormSubmit', function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var placeholder, email, formId, eventName, id;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    placeholder = event.formPlaceholder.querySelector('form input[type=email]');
                    if (!placeholder) {
                        logger.debugError('Dynamics365MarketingPlugin: Unable to find form placeholder');
                        return [2 /*return*/];
                    }
                    email = placeholder.value;
                    formId = event.getFormPageId();
                    eventName = formIdToNameMappings[formId] || 'form-submitted';
                    return [4 /*yield*/, getHashOrNull(options.shouldHash || false, email)];
                case 1:
                    id = _a.sent();
                    return [4 /*yield*/, analytics.identify(id, { email: email })];
                case 2:
                    _a.sent();
                    logger.debug("Dynamics365MarketingPlugin: Identifying user");
                    return [4 /*yield*/, analytics.track(eventName, { version: version })];
                case 3:
                    _a.sent();
                    logger.debug("Dynamics365MarketingPlugin: Tracked form submission");
                    return [2 /*return*/];
            }
        });
    }); });
});
//# sourceMappingURL=index.js.map